var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.843 8.65033L9.34297 1.15033C9.03048 0.840392 8.60809 0.666642 8.16797 0.666993H2.33464C1.89261 0.666993 1.46869 0.842587 1.15612 1.15515C0.843564 1.46771 0.667969 1.89163 0.667969 2.33366V8.16699C0.667795 8.38692 0.711149 8.60471 0.795533 8.8078C0.879917 9.01089 1.00366 9.19528 1.15964 9.35033L8.65964 16.8503C8.97212 17.1603 9.39452 17.334 9.83464 17.3337C10.276 17.3318 10.6985 17.155 11.0096 16.842L16.843 11.0087C17.156 10.6975 17.3328 10.275 17.3346 9.83366C17.3348 9.61373 17.2915 9.39595 17.2071 9.19285C17.1227 8.98976 16.9989 8.80537 16.843 8.65033ZM9.83464 15.667L2.33464 8.16699V2.33366H8.16797L15.668 9.83366M4.41797 3.16699C4.6652 3.16699 4.90687 3.2403 5.11243 3.37766C5.31799 3.51501 5.47821 3.71023 5.57282 3.93864C5.66743 4.16705 5.69218 4.41838 5.64395 4.66086C5.59572 4.90333 5.47667 5.12606 5.30185 5.30088C5.12704 5.47569 4.90431 5.59474 4.66183 5.64297C4.41936 5.69121 4.16802 5.66645 3.93962 5.57184C3.71121 5.47723 3.51598 5.31702 3.37863 5.11146C3.24128 4.90589 3.16797 4.66422 3.16797 4.41699C3.16797 4.08547 3.29967 3.76753 3.53409 3.53311C3.76851 3.29869 4.08645 3.16699 4.41797 3.16699Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/product.649050d1755dcab2848dca2343a4ff4b.svg";
export { ForwardRef as ReactComponent };